// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wizard-container{margin-top:2rem;border-radius:1rem;border-color:#1C3144;border-width:0.2rem;border-style:ridge}.wizard-title{vertical-align:middle;border-bottom:solid 1px black;margin-bottom:1rem}.wizard-title h4{font-size:x-large}.wizard-step-content{margin-left:1rem;margin-right:1rem;font-size:medium}.wizard-step-title{font-size:larger}.wizard-step-buttons{margin-top:1rem}\n", ""]);
// Exports
module.exports = exports;
